(function(){
'use strict';

angular.module('classy').constant('CHAR_LIMITS', {
  DEFAULT_ALT_TEXT: 255,
  DEFAULT_PAGE_APPEAL: 255,
  DEFAULT_PAGE_POST_TITLE: 245,
  DEFAULT_PAGE_COMMENT: 1000,
  DEFAULT_PAGE_CUSTOM_QUESTION: 255
});
})();